<template>
  <div class="form-progress-wrap edit-profile basic-info-wrap">
    <BaseLoading  opaque :spinning="athleteLoading">
      <div class="container">
        <div class="steps-content">
          <div class="general-form-wrap">
            <div class="general-form">
              <FormModel
                layout="horizontal"
                ref="form"
                :form="form"
                :model="resource"
                :rules="validationRules"
                @submit="handleSubmit"
              >
                <div class="image-upload box-wrapper">
                  <div class="heading">
                    <h2 class="form-title">Upload Profile Image</h2>
                  </div>
                  <a-form-item>
                    <div class="dropbox athlete-info-image-wrapper">
                      <BaseDragUpload
                        label="Click this area to upload or change photo"
                        cannot-delete
                        @file-upload="
                          image => {
                            imageSrc = image;
                          }
                        "
                        :image-url="athleteImageUrl"
                      />
                    </div>
                  </a-form-item>
                </div>

                <div class="general-info box-wrapper">
                  <div class="heading">
                    <h2 class="form-title">General Information</h2>
                  </div>
                  <a-row :gutter="32">
                    <a-col :sm="24" :md="10">
                      <a-row :gutter="16">
                        <a-col :sm="24">
                          <BaseFormInput
                            ref="athletename"
                            name="athletename"
                            placeholder="Enter athlete name"
                            label="Athlete Name"
                            :value="resource.athletename"
                            @change="
                              event =>
                                handleFormItemChange(
                                  'athletename',
                                  event.target.value
                                )
                            "
                          />
                        </a-col>
                        <a-col :sm="12">
                          <BaseFormInput
                            ref="city"
                            name="city"
                            placeholder="Enter city name"
                            label="City"
                            :value="resource.city"
                            @change="
                              event =>
                                handleFormItemChange('city', event.target.value)
                            "
                          />
                        </a-col>
                        <a-col :sm="12">
                          <BaseSortedTaxonomySelect
                            resource="playerState"
                            placeholder="Select State"
                            type="Player State"
                            label="State"
                            :value="resource.stateId || undefined"
                            @change="
                              value => handleFormItemChange('stateId', value)
                            "
                            class="grid-item-11"
                            name="state"
                          />
                        </a-col>
                        <a-col
                          :sm="24"
                          v-if="currentState === '603643ba773b8218e8268c86'"
                        >
                          <BaseSelect
                            :value="resource.countryId"
                            :items="countryList"
                            label="Country"
                            labelPath="name"
                            option-filter-prop="children"
                            show-search
                            filter-option
                            valuePath="_id"
                            @change="
                              value => handleFormItemChange('countryId', value)
                            "
                          />
                        </a-col>
                      </a-row>
                    </a-col>

                    <a-col :sm="24" :md="6">
                      <a-row :gutter="16">
                        <a-col :sm="24">
                          <div class="ant-col ant-form-item-label">
                            <label class="ant-form-item-required">Height</label>
                          </div>
                          <a-row :gutter="16">
                            <a-col :sm="12">
                              <BaseFormInput
                                ref="heightInFeet"
                                name="heightInFeet"
                                placeholder="Feet"
                                :value="resource.heightInFeet || undefined"
                                type="number"
                                @change="
                                  event =>
                                    handleFormItemChange(
                                      'heightInFeet',
                                      event.target.value
                                    )
                                "
                              />
                            </a-col>
                            <a-col :sm="12">
                              <BaseFormInput
                                ref="heightInInches"
                                name="heightInInch"
                                placeholder="Inches"
                                :value="resource.heightInInch"
                                type="number"
                                @change="
                                  event =>
                                    handleFormItemChange(
                                      'heightInInch',
                                      event.target.value
                                    )
                                "
                              />
                            </a-col>
                          </a-row>
                        </a-col>
                        <a-col :sm="24">
                          <BaseFormInput
                            name="weight"
                            placeholder="Weight(lbs)"
                            :value="resource.weight || undefined"
                            label="Weight(lbs)"
                            @change="
                              event =>
                                handleFormItemChange(
                                  'weight',
                                  event.target.value
                                )
                            "
                          />
                        </a-col>
                      </a-row>
                    </a-col>

                    <a-col :sm="24" :md="8">
                      <div class="ant-col ant-form-item-label">
                        <label class="ant-form-item-required">Birthdate</label>
                      </div>
                      <a-row :gutter="16">
                        <a-col :sm="8">
                          <BaseSelect
                            ref="birthDay"
                            name="birthDay"
                            labelPath="label"
                            valuePath="value"
                            :value="resource.birthDay"
                            :items="dayList"
                            @change="
                              value => handleFormItemChange('birthDay', value)
                            "
                          />
                        </a-col>
                        <a-col :sm="8">
                          <BaseSelect
                            ref="birthMonth"
                            name="birthMonth"
                            labelPath="label"
                            valuePath="value"
                            :value="resource.birthMonth"
                            :items="monthList"
                            @change="
                              value => handleFormItemChange('birthMonth', value)
                            "
                          />
                        </a-col>
                        <a-col :sm="8">
                          <BaseSelect
                            ref="birthYear"
                            name="birthYear"
                            labelPath="label"
                            valuePath="value"
                            :value="resource.birthYear"
                            :items="yearList"
                            @change="
                              value => handleFormItemChange('birthYear', value)
                            "
                          />
                        </a-col>
                      </a-row>
                    </a-col>
                  </a-row>
                </div>
                <a-form-item>
                  <a-button
                    type="primary"
                    html-type="submit"
                    class="next-button"
                    >Save</a-button
                  >
                </a-form-item>
              </FormModel>
            </div>
          </div>
        </div>
      </div>
    </BaseLoading>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { Athlete } from "@/models";
import { FormModel } from "ant-design-vue";

import { RepositoryFactory } from "../../../../../repositories/RepositoryFactory";
const STORE_KEY = "athleteStore";
const TaxonomyRepository = RepositoryFactory.get("taxonomy");

function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some(field => fieldsError[field]);
}

function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
}

export default {
  name: "BasicInfo",
  props: ["id"],
  components: {
    FormModel
  },
  data() {
    return {
      validationRules: Athlete.basicValidationRules,
      resource: new Athlete(),
      imageSrc: "",
      imageUrl: "",
      stateList: [],
      countryList: [],
      currentState: "",
      collegeList: [],
      dayList: [],
      country: "",
      monthList: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
      ],
      yearList: [],
      previewVisible: false,
      previewImage: "",
      fileList: [],
      hasErrors,
      form: this.$form.createForm(this)
    };
  },
  mounted() {
    this.$store.dispatch(`${STORE_KEY}/getAthlete`, { id: this.athleteId });
  },
  created() {
    TaxonomyRepository.getTaxonomyValues("Player State").then(response => {
      this.stateList = response.data.taxonomy.values;
    });
    let today = new Date();
    let year = today.getFullYear();
    for (let i = year; i >= year - 50; i--) {
      this.yearList.push({ label: i, value: i });
    }
    for (let i = 1; i < 32; i++) {
      this.dayList.push({ label: i, value: i });
    }
  },
  computed: {
    ...mapGetters({
      ProfileData: `${STORE_KEY}/getViewProfileData`,
      athlete: `${STORE_KEY}/athlete`,
      athleteLoading: `${STORE_KEY}/athleteLoading`
    }),
    athleteId() {
      return this.id || this.$route.params.profileId;
    },
    countryName() {
      return this.resource.country ? this.resource.country.name : "";
    },
    athleteImageUrl() {
      return this.athlete.profileImage;
    }
  },
  methods: {
    ...mapActions({
      setPlayerDetailInfo: `${STORE_KEY}/setPlayerDetailInfo`
    }),
    handleFormItemChange(key, value) {
      this.resource[key] = value;
      if (key === "stateId") {
        this.currentState = value;
        this.handleStateChange(value);
      }
    },
    handleStateChange(value) {
      this.currentState = value;
      this.country = this.resource.country ? this.resource.country.name : "";
      if (value === "603643ba773b8218e8268c86") {
        TaxonomyRepository.getTaxonomyValues("Country").then(response => {
          this.countryList = response.data.taxonomy.values;
        });
      }
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    // Only show error after a field is touched.
    handleError(val) {
      const { getFieldError, isFieldTouched } = this.form;
      return isFieldTouched(val) && getFieldError(val);
    },

    // Upload functions
    handleCancel() {
      this.previewVisible = false;
    },

    async handlePreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj);
      }
      this.previewImage = file.thumbUrl;
      this.previewVisible = true;
    },

    handleUploadChange(info) {
      let fileList = [...info.fileList];

      // 1. Limit the number of uploaded files
      //    Only to show two recent uploaded files, and old ones will be replaced by the new
      fileList = fileList.slice(-1);

      // 2. read from response and show file link
      fileList = fileList.map(file => {
        if (file.response) {
          // Component will show file.url as link
          file.url = file.response.url;
        }
        return file;
      });

      this.fileList = fileList;

      const status = info.file.status;

      if (status === "done") {
        this.$message.success(`${info.file.name} file uploaded successfully.`);
      } else if (status === "error") {
        this.$message.error(`${info.file.name} file upload failed.`);
      }
    },

    // Submit value
    async handleSubmit(e) {
      e.preventDefault();
      this.$refs.form.validate(async (valid, error) => {
        if (!valid) this.$refs[Object.keys(error)[0]].$refs.formInput.focus();
        if (valid) {
          let formData = new FormData();
          formData.append("file", this.imageSrc);
          formData.append("id", this.athleteId);
          this.imageSrc &&
            (await this.$store.dispatch(
              `${STORE_KEY}/updateAthleteImage`,
              formData
            ));
          this.imageSrc = "";
          const params = {
            id: this.athleteId,
            athletename: this.resource.athletename,
            heightInFeet: this.resource.heightInFeet,
            heightInInch: this.resource.heightInInch,
            birthDay: this.resource.birthDay,
            birthMonth: this.resource.birthMonth,
            birthYear: this.resource.birthYear,
            city: this.resource.city,
            state: this.resource.stateId,
            weight: this.resource.weight,
            country: this.resource.countryId,
            slug: "athlete",
            message: "Basic Information Updated"
          };
          if (!params.country) delete params.country;
          await this.$store.dispatch(`${STORE_KEY}/updateAthlete`, params);
          await this.$store.dispatch(`${STORE_KEY}/getAthlete`, {
            id: this.athleteId
          });
        }
      });
    }
  },
  watch: {
    athlete(newVal) {
      this.resource = new Athlete(newVal);
      this.handleStateChange(newVal.stateId);
      this.currentState = newVal.stateId;
    },
    "resource.heightInFeet": {
      deep: true,
      immediate: true,
      handler: function(newVal) {
        if (newVal > 7 || newVal < 1) {
          this.resource.heightInFeet = 1;
        }
      }
    },
    "resource.heightInInch": {
      deep: true,
      immediate: true,
      handler: function(newVal) {
        if (newVal > 11 || newVal < 1) {
          this.resource.heightInInch = 0;
        }
      }
    }
  }
};
</script>
<style lang="scss">
.athlete-info-image-wrapper {
  label {
    display: none;
  }
  .upload-wrapper {
    place-content: center;
  }
  .upload-button-wrapper {
    width: 60% !important;
  }
}
.edit-profile {
  .steps-content {
    margin-top: 0 !important;
  }
  .general-form-wrap {
    .dropbox {
      > span {
        display: flex;
        flex-direction: column-reverse;
        .ant-upload {
          &.ant-upload-drag {
            margin: 30px 0 0;
            width: 100%;
            max-width: 600px;
          }
        }
      }
    }
  }
}
</style>
